export const formatSequence = (value) => {
  let sequence = ''
  let toUpper = true
  for (const letter of value) {
    if (letter === '[') {
      toUpper = false
    }
    if (letter === ']') {
      toUpper = true
    }
    if (toUpper) {
      sequence = sequence + letter.toUpperCase()
    } else {
      sequence = sequence + letter
    }
  }
  return sequence
}

export const sequenceCount = (value) => {
  let sequenceCount = 0
  let toCountInternalMod = true
  for (const letter of value) {
    if (letter === '[') {
      toCountInternalMod = false
    }
    if (letter === ']') {
      toCountInternalMod = true
    }
    if (toCountInternalMod && letter !== '*' && letter !== ' ') {
      sequenceCount = sequenceCount + 1
    }
  }
  return sequenceCount
}
